// production url
export const API_URL = "https://api.complaintdeskonline.com/api/v1";

export const APP_NAME = "CMS";
